import { PaymentsConfig1 } from '@frontend/api-payments-config';
import { SelectedLocationProvider } from '@frontend/payments-hooks';
import { useAppScopeStore } from '@frontend/scope';
import { ContentLoader, useAlert } from '@frontend/design-system';
import { PaymentSettingsGroup } from '../atoms/payment-settings-group';
import { Merchant } from '../sections/merchant-status/merchant';

export const MerchantStatusGroup = () => {
  const { selectedLocationIds: locationIds } = useAppScopeStore();
  const alert = useAlert();

  const { data, isLoading } = PaymentsConfig1.Queries.useGetMultiLocationProcessorsQuery({
    request: {
      locationIds,
    },
    options: {
      onError: (error) => {
        console.error('Error fetching payment processors:', error);
        alert.error('Error fetching payment processors');
      },
    },
  });

  return (
    <section>
      <ContentLoader show={isLoading} />
      {locationIds.length === 1 ? (
        <SelectedLocationProvider locationId={locationIds[0]}>
          <Merchant processors={data?.processors} />
        </SelectedLocationProvider>
      ) : (
        <PaymentSettingsGroup includeNonPaymentLocations>
          <Merchant processors={data?.processors} isInMultiLocationSetup />
        </PaymentSettingsGroup>
      )}
    </section>
  );
};
